import type { ClientGateway } from "@kex/api";

import { useMutation } from "@tanstack/react-query";

import { requisitesApi } from "@shared/api";

import { useRequisitesQuery } from "./use-requisites-query";

interface UseEditRequisitesParams {
  id: string;
}

interface QueryData {
  payload: ClientGateway.EditBankAccountRequest;
  xTOTP: string;
}

export const useEditRequisites = ({ id }: UseEditRequisitesParams) => {
  const { invalidateRequisites } = useRequisitesQuery();

  const { error, mutateAsync, isPending } = useMutation({
    mutationFn: (data: QueryData) =>
      requisitesApi.patchApiV1BankAccountsId({
        id,
        editBankAccountRequest: data.payload,
        xTOTP: data.xTOTP,
      }),
    onSettled: invalidateRequisites,
  });

  return { editRequisites: mutateAsync, error, isPending };
};
